import { Component, OnInit, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { applyFroalaAriaFix, stripFroalaWatermark } from '../../utils/froala.utils';

@Component({
    selector: 'text-editor',
    templateUrl: './text-editor.component.html',
    styleUrls: ['./text-editor.component.scss'],
    standalone: false
})
export class TextEditorComponent implements OnInit, OnDestroy {

    @Input() content: string = "";
    control: FormControl = new FormControl(this.content, []);
    requiredControl: FormControl = new FormControl(this.content, [Validators.required]);
    form: FormGroup;
    @Output() formBuilt: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
    key: string = '';

    private _options: any = applyFroalaAriaFix({
        heightMax: 500,
        height: 500,
        heightMin: 150,
        saveInterval: 0,
        toolbarButtons: ["fullScreen", "html", "undo", "redo", "bold", "italic", "underline", 'strikeThrough', "align", "fontSize", "paragraphFormat", "indent", "color" ],
        typingTimer: 150,
        autofocus: true
    });

    get froalaOptions(): any {
        let conf = window["PdfConfig"] as any;
        this.key = (conf != null) ? conf.editorLicenseKey : "";
        (this._options as any).key = this.key;
        return this._options;
    }

    @Input() set froalaOptions(options: any) {
        let conf = window["PdfConfig"] as any;
        this.key = (conf != null) ? conf.editorLicenseKey : "";
        options.key = this.key;
        this._options = applyFroalaAriaFix(options);
    }


    @Input() required: boolean = false;


    constructor() { }

    ngOnInit() {
        this.form = this.required
            ? new FormGroup({ "content": this.requiredControl })
            : new FormGroup({ "content": this.control });
        this.form.get("content").patchValue(this.content);

        this.form.get("content").valueChanges.subscribe((val: string) => {
            const cleaned = stripFroalaWatermark(val);
            if (cleaned !== val) {
                this.form.get("content").patchValue(cleaned, { emitEvent: false });
            }
        });

        this.formBuilt.emit(this.form);
    }

    ngOnDestroy() {

    }

}
